import { doc, getDoc } from 'firebase/firestore';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { STATISTICS_REDUCER_NAME } from '../types';
import { COLLECTION } from '../../../../firestore/collectionNames';
import { firestoreDateMapper } from '../../../../helpers/firestoreDateMapper';
import { CreatorMonthStatsDocument } from '../../../../models/documents/Reports';
import dayjs from 'dayjs';

export const fetchCurrentMonthStats = createAsyncThunk<
  CreatorMonthStatsDocument | null,
  void,
  AsyncThunkCreator<number>
>(
  `${STATISTICS_REDUCER_NAME}/fetchCurrentMonthStats`,
  async (_, { rejectWithValue, extra: { auth, db } }) => {
    try {
      const user = auth().currentUser;
      if (!user) {
        throw new Error('user-is-not-logged');
      }

      const today = dayjs();
      const ref = doc(
        db,
        COLLECTION.REPORTS,
        user.uid,
        COLLECTION.STATS_PER_MONTH,
        today.format('YYYY-M')
      );

      const docSnap = await getDoc(ref);

      return docSnap.exists() ? firestoreDateMapper<CreatorMonthStatsDocument>(docSnap) : null;
    } catch (e) {
      const error = e as any;

      return rejectWithValue(error.message);
    }
  }
);
